import axios from 'axios'

export default class OperationsCenterService {

    oAuth2WellKnownUrl() {
        return axios.get('https://signin.johndeere.com/oauth2/aus78tnlaysMraFhC1t7/.well-known/oauth-authorization-server').then(response => response.data)
    }
}
